/** @format */

import { Container } from "../../components/layouts/Container";
import { EconomicEstimateElement } from "../../components/ui_elements";

const EconomicEstimate = () => {
  return (
    <Container isLogin={true} background={"default"} align={"top"}>
      <EconomicEstimateElement />
    </Container>
  );
};

export default EconomicEstimate;
